import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchRoles = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/roles', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_ROLES,
      payload: {
        roles: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchRole = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/roles/${id}`).then(response => {
    dispatch({
      type: types.FETCH_ROLE,
      payload: {
        name: response.name,
        shortName: response.shortName,
        permissions: response.permissions,
      },
    });
    return response;
  });

export const removeRole = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/roles/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_ROLE,
      payload: {
        roleId: id,
      },
    });
  });
